import { render } from "./Register.vue?vue&type=template&id=e59c811e"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "e59c811e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e59c811e', script)) {
    api.reload('e59c811e', script)
  }
  
  module.hot.accept("./Register.vue?vue&type=template&id=e59c811e", () => {
    api.rerender('e59c811e', render)
  })

}

script.__file = "resources/js/Pages/Auth/Register.vue"

export default script